import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { Post } from '../../../activityfeed/src/ActivityFeedController'
import PostBody from '../../../activityfeed/src/PostBody.web'
import PostFooter from '../../../activityfeed/src/PostFooter.web'
import PostHeader from '../../../activityfeed/src/PostHeader.web'
import { ownerShipIcon, profileLogo } from '../../../activityfeed/src/assests'
import { getBorderRadiusClass, highlightText, verifyImg } from '../../../../components/src/utils'
import { CommentData, Media } from '../../../comments/src/CommentsController.web'
import moment from 'moment'
import ReactPlayer from 'react-player'

interface ReplyItemProps {
	navigation?: any
	checked: boolean
	postData: Post
	replyData: CommentData
	onFollow: (id: number, type: string) => void,
	onClickMoreOption: (activeUser: any, postId: string) => void
	onMuteConformation: () => void
	onShowReportPost: () => void
	onBlockAccount: (id: number) => void
	onPinPost: (pinned: boolean) => void
	onCommentSetting: () => void
	onDeletePost?: () => void
	onToggleRemoveAddUserCustomList: (userId: number, isAdd: boolean) => void
	onLikePost: (id: string, type: string, likeableType: string) => void
	onSavePost: (id: string, type: string) => void
	onClickComments: (postId: string) => void
	showPostActivity?: (id?: string, postedById?: number) => void
	onClickRepost: (postId: string) => void
}

const ReplyItem: React.FC<ReplyItemProps> = ({
	navigation,
	checked,
	postData,
	replyData,
	onFollow,
	onClickMoreOption,
	onMuteConformation,
	onShowReportPost,
	onBlockAccount,
	onPinPost,
	onCommentSetting,
	onDeletePost,
	onToggleRemoveAddUserCustomList,
	onLikePost,
	onSavePost,
	onClickComments,
	showPostActivity,
	onClickRepost,
}) => {
	const classes = useStyles()

	const highlights = [...replyData.attributes.body_mentions, ...replyData.attributes.hash_tags];
	const highlightedBody = replyData.attributes.body && highlightText(replyData.attributes.body, highlights);

	const renderCommentMedia = (classes: any, src: Media, index: number, length: number) => {
		const borderRadiusClass = getBorderRadiusClass(index, length, classes)
		if (src.content_type.startsWith("image")) {
			return (
				<img
					key={src.id}
					src={src.url}
					loading="lazy"
					alt="post"
					style={{ height: length > 2 ? "165px" : "264px" }}
					className={`${classes.postImageStyle} ${borderRadiusClass}`}
				/>
			)
		} else if (src.content_type.startsWith("video")) {
			return (
				<div
					key={src.id}
					className={`${classes.postImageStyle} ${borderRadiusClass}`}
					style={{ height: length > 2 ? "165px" : "264px" }}
				>
					<ReactPlayer
						url={src.url}
						controls={true}
						loading="lazy"
						className={`${classes.reactPlayerStyle} ${borderRadiusClass}`}
					/>
				</div>
			)
		}
		else if (src.content_type.startsWith("audio")) {
			return (
				<audio key={src.id} src={src.url} controls >
					Your browser does not support the audio element.
				</audio>
			)
		}
	}

	return (
		<Box className={classes.container}>
			<Box className={classes.postContainer}>
				<Box className={classes.imageContainer}>
					<img
						src={profileLogo}
						alt="profile-photo"
						className={classes.postImage}
					/>
					<div className={classes.verticalLine} />
				</Box>
				<Box className={classes.postWrapper}>
					<PostHeader
						data-testid="postHeader"
						checked={checked}
						onFollow={onFollow}
						onClickMoreOption={onClickMoreOption}
						navigation={navigation}
						onMuteConformation={onMuteConformation}
						onShowReportPost={onShowReportPost}
						onBlockAccount={onBlockAccount}
						onPinPost={onPinPost}
						onCommentSetting={onCommentSetting}
						onDeletePost={onDeletePost}
						postData={postData}
						onToggleRemoveAddUserCustomList={onToggleRemoveAddUserCustomList}
						isReplyItem
					/>
					<PostBody postData={postData} checked={checked} onClickComments={onClickComments} />
					<PostFooter
						checked={checked}
						data-testid="PostFooter"
						postData={postData}
						onLikePost={onLikePost}
						onSavePost={onSavePost}
						onClickComments={onClickComments}
						showPostActivity={showPostActivity}
						onClickRepost={onClickRepost}
					/>
				</Box>
			</Box>
			<Box className={classes.replyContainer}>
				<Box className={classes.imageContainer}>
					<img
						src={replyData.attributes.comment_by.profile_photo || profileLogo}
						alt="profile-photo"
						className={classes.postImage}
					/>
				</Box>
				<Box style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
					<Box style={{ display: "flex", gap: "5px", alignItems: "center" }}>
						<Typography
							style={{
								color: checked ? "#222222" : "#FFFFFF",
								fontSize: "18px",
								fontFamily: "Manrope",
								fontWeight: 800,
								lineHeight: "21px",
								whiteSpace: "nowrap",
							}}
						>
							{replyData.attributes.comment_by.full_name}
						</Typography>
						<img
							src={verifyImg(replyData.attributes.comment_by.user_subscription)}
							alt="verify-icon"
						/>
						{true && <img src={ownerShipIcon} alt="" />}
						<Typography style={{
							fontSize: "12px",
							fontFamily: "Manrope",
							fontWeight: 500,
							lineHeight: "14px",
							whiteSpace: "nowrap" as "nowrap",
							color: "#6B6B6B",
						}}>
							{replyData.attributes.comment_by.user_name}
						</Typography>
					</Box>
					<Typography
						style={{
							color: "#6B6B6B",
							fontSize: "11px",
							fontFamily: "Manrope",
							fontWeight: 400,
							lineHeight: "15px",
						}}
					>
						{moment(replyData.attributes.created_at).fromNow()}
					</Typography>
					<Typography
						className={classes.commentText}
						style={{ color: checked ? '#222222' : '#FFF' }}
					>
						{highlightedBody.split('\r\n').map((line, index) => (
							<React.Fragment key={index}>
								<Typography
									className={classes.commentText}
									dangerouslySetInnerHTML={{ __html: line }}
								/>
								<br style={{ lineHeight: 0 }} />
							</React.Fragment>
						))}
					</Typography>
					<Box
						className={replyData.attributes.media.length > 1 ? classes.feedmultiImages : classes.feedImages}
					>
						{replyData.attributes.media.map((media: Media, index: number) => (
							renderCommentMedia(classes, media, index, replyData.attributes.media.length)
						))}
					</Box>
				</Box>
			</Box>
		</Box>
	)
}

const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		padding: '8px 0px 20px',
	},

	postContainer: {
		display: 'flex',
		marginLeft: '24px',
		gap: '10px',
	},

	postWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		flex: 1,
		paddingBottom: '10px',
	},

	imageContainer: {
		position: "relative",
		display: "block",
	},

	postImage: {
		height: "35px",
		width: "35px",
		borderRadius: "50%",
		objectFit: "cover",
	},

	verticalLine: {
		position: "absolute",
		bottom: 0,
		left: "50%",
		transform: "translateX(-50%)",
		width: "1px",
		height: 'calc(100% - 35px)',
		backgroundColor: "#ccc",
	},

	replyContainer: {
		display: 'flex',
		marginLeft: '24px',
		gap: '10px',
	},
	commentText: {
		fontFamily: 'Manrope',
		fontSize: '14px',
		fontWeight: 500,
	},
	feedmultiImages: {
		display: "grid",
		gridTemplateColumns: '1fr 1fr',
		gap: "10px",
	},
	feedImages: {
		display: "grid",
		gap: "10px",
	},
}))

export default ReplyItem
